import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const StyledButton = styled(motion.button)`
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: white;
  padding: 1rem 2.5rem;
  border-radius: 30px;
  font-weight: 200;
  font-size: 1.1rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: 1px solid #3b82f6;
  box-shadow: 0 0 20px rgba(29, 78, 216, 0.4);
  
  transition: background 0.5s ease, color 0.5s ease, box-shadow 0.5s ease, border 0.5s ease;

  &:hover {
    background: linear-gradient(135deg, #1d4ed8, #3b82f6);
    color: white;
    border: 1px solid #3b82f6;
    box-shadow: 0 0 25px rgba(59, 130, 246, 0.6);
  }
`;

const DownloadButton = ({ children, onClick, ...props }) => (
  <StyledButton
    whileHover={{ scale: 1 }}
    whileTap={{ scale: 1 }}
    onClick={onClick}
    {...props}
  >
    {children}
  </StyledButton>
);

export default DownloadButton;
